import React from 'react';


export default ({color}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 15 12">
      <path fill={color || '#0092e5'} d="M188.137,266.49l2.711,2.711,8.458-8.458a1.123,1.123,0,0,1,1.587,0h0a1.123,1.123,0,0,1,0,1.587l-10.045,10.045h0l-4.3-4.3a1.122,1.122,0,0,1,0-1.588h0A1.123,1.123,0,0,1,188.137,266.49Z" transform="translate(-186.221 -260.414)"/></svg>
  )
}